import {createAction} from '@reduxjs/toolkit';

export const includeExtent = createAction('MAP_INCLUDE_EXTENT');
export const setExtent = createAction('MAP_SET_EXTENT');
export const setView = createAction('MAP_SET_VIEW');
export const setZoomLevel = createAction('MAP_SET_ZOOM_LEVEL');
